import { GoalCategory } from '@fruitful/types';
import { type ColumnEditorOptions } from 'primereact/column';
import { Dropdown, type DropdownChangeEvent } from 'primereact/dropdown';
import React from 'react';

import { DropdownEditor } from '../../common/components/GridCellEditors';

const GoalCategoryOptions = Object.values(GoalCategory).map((value) => ({
    label: value,
    value,
}));

interface GoalCategoryDropdownEditorProps {
    options: ColumnEditorOptions;
}

export const GoalCategoryDropdownEditor = ({
    options,
}: GoalCategoryDropdownEditorProps) => {
    return (
        <DropdownEditor
            options={options}
            dropdownProps={{
                options: GoalCategoryOptions,
                placeholder: 'Category',
                appendTo: 'self',
                style: { transform: 'scale(0.85)', zIndex: 100 },
                panelStyle: {},
            }}
        />
    );
};

interface GoalCategoryDropdownProps {
    value: GoalCategory | null;
    onChange: (goalCategory: GoalCategory) => void;
}

export const GoalCategoryDropdown = ({
    onChange,
    value,
}: GoalCategoryDropdownProps) => {
    return (
        <Dropdown
            placeholder="Category"
            value={value}
            options={GoalCategoryOptions}
            onChange={(e: DropdownChangeEvent) => {
                onChange(e.value as GoalCategory);
            }}
            appendTo="self"
            style={{
                transform: 'scale(0.90)',
                zIndex: 100,
            }}
        />
    );
};
